module.exports = __webpack_public_path__ + "media/timbre.e8306c6c.mp3";